<template>
    <div>
        <ts-page-title
            :title="$t('bankProfile.pageTitle')"
            :breadcrumb="[
                { text: $t('home'), href: '/' },
                { text: $t('bankProfile.pageTitle'), active: true }
            ]"
        />
        <ts-panel>
            <ts-panel-wrapper
                class="tw-flex tw-items-center tw-justify-between"
            >
                <Button
                    type="info"
                    ghost
                    @click="$router.push({ name: 'bank-profile-create' })"
                >
                    {{ $t("addNew") }}
                </Button>
                <Input
                    search
                    v-model="search"
                    :placeholder="$t('bankProfile.search')"
                    style="width: 300px"
                />
            </ts-panel-wrapper>

            <Table
                :columns="columns"
                :data="resources"
                size="small"
                :loading="loading"
                stripe
            >
                <template slot-scope="{ row }" slot="action">
                    <a
                        href="#"
                        class="text-primary ml-2"
                        @click.prevent="onEdit(row)"
                        v-tooltip="$t('edit')"
                    >
                        <Icon type="ios-create" size="20" />
                    </a>
                    <Poptip
                        :title="$t('are_you_sure_to_delete')"
                        :transfer="true"
                        width="200"
                    >
                        <a
                            class="ml-2 text-danger"
                            v-tooltip="$t('delete')"
                            :disabled="row._deleting"
                        >
                            <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
                            <Icon type="ios-trash" size="20" v-else />
                        </a>
                        <div slot="content" class="tw-text-right tw-mt-2">
                            <a
                                class="ivu-btn ivu-btn-danger ivu-btn-small"
                                @click.prevent="onDelete(row)"
                            >
                                <span>{{ $t("ok") }}</span>
                            </a>
                        </div>
                    </Poptip>
                </template>
            </Table>

            <div class="tw-flex tw-items-center tw-justify-end tw-p-4">
                <ts-i-pagination
                    v-model="pagination"
                    @navigate="fetchData"
                ></ts-i-pagination>
            </div>
        </ts-panel>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { debounce } from "lodash";
import expandRow from "./table-expand.vue";

export default {
    name: "BankProfileIndex",
    data() {
        return {
            loading: false
        };
    },
    computed: {
        ...mapState("finance/bankProfile", ["resources", "pagination"]),
        search: {
            get() {
                return this.$store.state.finance.bankProfile.search;
            },
            set(value) {
                this.$store.commit("finance/bankProfile/SET_SEARCH", value);
                this.$store.commit("finance/bankProfile/RESET_CURRENT_PAGE");
            }
        },
        columns() {
            return [
                {
                    type: "expand",
                    width: 50,
                    render: (h, params) => {
                        return h(expandRow, { props: { row: params.row } });
                    }
                },
                {
                    title: "#",
                    key: "bank_id",
                    width: 70,
                    align: "center"
                },
                {
                    title: this.$t("bankProfile.bankName"),
                    key: "bank_name",
                    minWidth: 200
                },
                {
                    title: this.$t("bankProfile.accounts"),
                    key: "accounts",
                    minWidth: 120,
                    render: (h, { row }) => {
                        const count = row.accounts ? row.accounts.length : 0;
                        return h(
                            "span",
                            { class: "ivu-tag ivu-tag-size-default ivu-tag-default" },
                            count
                        );
                    }
                },
                {
                    title: this.$t("actions"),
                    slot: "action",
                    align: "center",
                    width: 100
                }
            ];
        }
    },
    methods: {
        fetchData(attributes = {}) {
            this.loading = true;
            this.$store
                .dispatch("finance/bankProfile/fetch", {
                    ...attributes,
                    filter: { search: this.search }
                })
                .finally(() => (this.loading = false));
        },
        onEdit(row) {
            this.$store.commit("finance/bankProfile/SET_EDIT_DATA", row);
            this.$router.push({
                name: "bank-profile-edit",
                params: { id: row.bank_id }
            });
        },
        onDelete(row) {
            row._deleting = true;
            this.$store
                .dispatch("finance/bankProfile/destroy", row.bank_id)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    this.fetchData();
                })
                .catch(error =>
                    this.notice({ type: "error", text: error.message })
                )
                .finally(() => (row._deleting = false));
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "BANK PROFILE",
                desc: not.text
            });
        }
    },
    watch: {
        search: debounce(function() {
            this.fetchData();
        }, 500)
    },
    beforeRouteEnter(to, from, next) {
        next(vm => vm.fetchData());
    }
};
</script>
